export const ConnectorBrandTile = (input: {
  iconKey: string;
  displayName: string;
  description: string;
  onClick: () => void;
}) => {
  const brandSurface: Record<string, { bg: string; fg: string; letter: string }> = {
    hubspot: { bg: "#ff7a59", fg: "#ffffff", letter: "H" },
    intercom: { bg: "#0057ff", fg: "#ffffff", letter: "I" },
    zendesk: { bg: "#03363d", fg: "#f6f6f6", letter: "Z" }
  };

  const surface = brandSurface[input.iconKey] ?? {
    bg: "#6b7280",
    fg: "#fff",
    letter: "?"
  };

  return (
    <button
      type="button"
      onClick={input.onClick}
      className="w-full rounded-lg border border-border p-4 text-left transition-shadow hover:border-primary/40 hover:shadow-sm"
    >
      <div className="flex flex-col gap-3">
        <div
          className="flex h-12 w-12 items-center justify-center rounded-xl text-lg font-bold"
          style={{ backgroundColor: surface.bg, color: surface.fg }}
        >
          {surface.letter}
        </div>
        <div>
          <p className="text-sm font-semibold">{input.displayName}</p>
          <p className="mt-1 line-clamp-3 text-xs text-muted-foreground">{input.description}</p>
        </div>
      </div>
    </button>
  );
};
